import { Ticker } from "./Ticker";

/**
 * The header ticker mount point (D-O61 W2, D-O64). The integrator mounts this in AppShell; renders the role-aware
 * header ticker inside `data-testid="ticker-mount"`.
 */
export function TickerSlot() {
  return <Ticker variant="header" />;
}

